import { machines } from '../machines/machines-sidecar'
import { scene } from '../main/scene-sidecar'
import { tilesDataShip } from '../tiles/tilesDataShip-sidecar'
import { addCargoToStack } from './testRig_common'
import { testRig_common } from './testRig_common-sidecar'

export const createTestRig_escapeShuttle = (x: number, y: number) => {
  let ctx = scene.getContext()

  let w = 14
  let h = 7
  let std = tilesDataShip.getStandard()

  testRig_common.createHullOutline(x + 2, y, w - 3, 4)
  testRig_common.createHullOutline(x, y + 3, w, 4)
  testRig_common.createLadder(x + 6, y + 1, 1, h - 2)

  // let mc = machines.create('door')
  // machines.moveToTile(mc, ctx.mapShip, x + 8, y + 2)

  let mc = machines.create('airlock2')
  machines.moveToTile(mc, ctx.mapShip, x + 3, y + 2)

  mc = machines.create('suits')
  machines.moveToTile(mc, ctx.mapShip, x + 5, y + 2)

  mc = machines.create('reactor-em')
  machines.moveToTile(mc, ctx.mapShip, x + 3, y + 5)

  mc = machines.create('engine')
  machines.moveToTile(mc, ctx.mapShip, x + 0, y + 5)

  mc = machines.create('water-cooler')
  machines.moveToTile(mc, ctx.mapShip, x + 8, y + 2)

  mc = machines.create('pile')
  machines.setHoldsType(mc, 'food')
  machines.moveToTile(mc, ctx.mapShip, x + 9, y + 2)
  addCargoToStack(mc, 3)

  mc = machines.create('o2gen-em')
  machines.moveToTile(mc, ctx.mapShip, x + 8, y + 5)

  mc = machines.create('pile')
  machines.setHoldsType(mc, 'water')
  machines.moveToTile(mc, ctx.mapShip, x + 9, y + 5)
  addCargoToStack(mc, 3)

  mc = machines.create('pile')
  machines.setHoldsType(mc, 'steel')
  machines.moveToTile(mc, ctx.mapShip, x + 10, y + 5)
  addCargoToStack(mc, 3)

  mc = machines.create('pile')
  //machines.setHoldsType(mc, '')
  machines.moveToTile(mc, ctx.mapShip, x + 11, y + 5)
}
